import './App.css';
import AppTheme from './theme';
import ErrorBoundary from './components/error-boundary/ErrorBoundary';
import React from 'react';
import store, { persistor } from './redux/store';
import { IntlProvider } from 'react-intl';
import { locale, messages } from './locales';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider as ReduxProvider } from 'react-redux';

function App() {
  return (
    <React.StrictMode>
      <ErrorBoundary>
        <ReduxProvider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <IntlProvider locale={locale} messages={messages}>
              <AppTheme>
                <div>
                  <div className='App' data-testid='app-container'>
                    Environment: {process.env.NODE_ENV}
                  </div>
                  <div className='App' data-testid='app-container1'>
                    REACT_APP_CI_COMMIT_REF_SLUG: {process.env.REACT_APP_CI_COMMIT_REF_SLUG}
                  </div>
                </div>
              </AppTheme>
            </IntlProvider>
          </PersistGate>
        </ReduxProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
}

export default App;
